import React from "react";
import { Navigate } from "react-router-dom";

export const isAuthenticated = () => {
  return !!localStorage.getItem("token");
};

const ProtectedRoute = ({ element: Component, ...rest }) => {
  return isAuthenticated() ? (
    <Component {...rest} />
  ) : (
    <Navigate to="/sign-in" />
  );
};

export default ProtectedRoute;
